import React, { FC, ReactNode, useState } from "react";
import imagePng from "images/hero-testimonials.png";
import avatar1 from "images/Testimonial_1.png";
import avatar2 from "images/Testimonial_2.png";
import avatar3 from "images/Testimonial_3.png";
import avatar4 from "images/Testimonial_4.png";
import HeroSearchForm, {
  SearchTab,
} from "components/HeroSearchForm/HeroSearchForm";
import Avatar from "shared/Avatar/Avatar";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";

export interface SectionHeroArchivePageProps {
  className?: string;
  listingType?: ReactNode;
  currentPage: "Stays" | "Experiences" | "Cars" | "Flights";
  currentTab: SearchTab;
  rightImage?: string;
}

const SectionHeroArchivePage: FC<SectionHeroArchivePageProps> = ({
  className = "",
  listingType,
  currentPage,
  currentTab,
  rightImage = imagePng,
}) => {
  const [showMore, setShowMore] = useState(false);

  const handleReadMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div
      className={`nc-SectionHeroArchivePage flex flex-col relative  ${className}`}
      data-nc-id="SectionHeroArchivePage"
    >
      <div className="flex flex-col lg:flex-row lg:pt-[10px]">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-6 lg:space-y-10 pb-10 lg:pb-64 xl:pb-80 xl:pr-14  xl:mr-0">
          <h2 className="text-3xl md:text-4xl font-semibold ">
            Testimonials
          </h2>
          <div className=" w-[365px] font-normal text-base  text-neutral-500">
            Achieve a decisive competitive advantage with the industry's leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement. Achieve a decisive competitive advantage with the industry’s leading cloud-native, procurement. Achieve a decisive competitive advantage and indirect procurement.
          </div>

        </div>
        <div className="flex flex-row justify-center items-center pb-[35px]">
          <div className="flex-col ">
            {showMore ? (
              <>
                <div className="m-[15px]  p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                    <Avatar
                      hasChecked
                      hasCheckedClass="w-0 h-0 "
                      sizeClass="h-[70px] w-[70px]"
                      radius="rounded-full"
                      imgUrl={avatar1}
                    />
                    <div >
                      <a className="block text-md font-semibold">
                        David
                      </a>
                      <a className="block text-md font-semibold mt-[-3px]">
                      Silverman
                      </a>

                    </div>
                  </div>
                  <div className=" py-[10px] ">
                    <FiveStartIconForRate defaultPoint={5.0} iconClass="w-3 h-3" className="space-x-0.5"  />
                  </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                  Buying in the Caribbean was always a dream of mine. I can’t think of a better place to do it than in DR, but I’m glad Paradise Living made it easy for me. Couldn’t ask for a more professional team to help me making this a reality.
                  </div>
                </div>
                <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                    <Avatar
                      hasChecked
                      hasCheckedClass="w-0 h-0 "
                      sizeClass="h-[70px] w-[70px]"
                      radius="rounded-full"
                      imgUrl={avatar2}
                    />
                    <div >
                      <a className="block text-md font-semibold">
                      Manuel
                      </a>
                      <a className="block text-md font-semibold mt-[-3px]">
                      Vazquez
                      </a>

                    </div>
                  </div>
                  <div className=" py-[10px] ">
                    <FiveStartIconForRate defaultPoint={4.8} iconClass="w-3 h-3" className="space-x-0.5" />
                  </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                  After living in the US for 30 years my goal was always to retire in my home country. I was putting my life savings into it so I was really nervous about it but Paradise Living made me feel I was not alone. 100% recommended.
                  </div>
                </div>
                <div className="m-[15px]  p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                    <Avatar
                      hasChecked
                      hasCheckedClass="w-0 h-0 "
                      sizeClass="h-[70px] w-[70px]"
                      radius="rounded-full"
                      imgUrl={avatar3}
                    />
                    <div >
                      <a className="block text-md font-semibold">
                         Ronda
                      </a>
                      <a className="block text-md font-semibold mt-[-3px]">
                        Johnson
                      </a>

                    </div>
                  </div>
                  <div className=" py-[10px] ">
                    <FiveStartIconForRate defaultPoint={4.9} iconClass="w-3 h-3" className="space-x-0.5" />
                  </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                  Smooth sailing from the beginning to the end. That’s all I have to say. Good to know there are people are there that are protecting your decision making. Extremely professional and reliable.
                  </div>
                </div>
                <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                    <Avatar
                      hasChecked
                      hasCheckedClass="w-0 h-0 "
                      sizeClass="h-[70px] w-[70px]"
                      radius="rounded-full"
                      imgUrl={avatar4}
                    />
                    <div >
                      <a className="block text-md font-semibold">
                        Crystal
                      </a>
                      <a className="block text-md font-semibold mt-[-3px]">
                        Garner
                      </a>

                    </div>
                  </div>
                  <div className=" py-[10px] ">
                    <FiveStartIconForRate defaultPoint={5.0} iconClass="w-3 h-3" className="space-x-0.5" />
                  </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                  Best decision of my life. I can’t say enough about my experience. I dealt with many Real Estate Agents in the past and everything I heard was “Buy, buy buy”. The team at Paradise Living held my hand and work with me to find not just what I wanted but what I need it. Superstar team.
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="m-[15px]  p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                    <Avatar
                      hasChecked
                      hasCheckedClass="w-0 h-0 "
                      sizeClass="h-[70px] w-[70px]"
                      radius="rounded-full"
                      imgUrl={avatar1}
                    />
                    <div >
                      <a className="block text-md font-semibold">
                      David
                      </a>
                      <a className="block text-md font-semibold mt-[-3px]">
                      Silverman
                      </a>

                    </div>
                  </div>
                  <div className=" py-[10px] ">
                    <FiveStartIconForRate defaultPoint={5.0} iconClass="w-3 h-3" className="space-x-0.5" />
                  </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                  Buying in the Caribbean was always a dream of mine. I can’t think of a better place to do it than in DR, but I’m glad Paradise Living made it easy for me. Couldn’t ask for a more professional team to help me making this a reality.
                  </div>
                </div>
                <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
                  <div className="flex items-center space-x-4 ">
                    <Avatar
                      hasChecked
                      hasCheckedClass="w-0 h-0 "
                      sizeClass="h-[70px] w-[70px]"
                      radius="rounded-full"
                      imgUrl={avatar2}
                    />
                    <div >
                      <a className="block text-md font-semibold">
                        Manuel
                      </a>
                      <a className="block text-md font-semibold mt-[-3px]">
                      Vazquez
                      </a>

                    </div>
                  </div>
                  <div className=" py-[10px] ">
                    <FiveStartIconForRate defaultPoint={4.8} iconClass="w-3 h-3" className="space-x-0.5" />
                  </div>
                  <div className="py-[2px] text-[10px] leading-normal font-light">
                  After living in the US for 30 years my goal was always to retire in my home country. I was putting my life savings into it so I was really nervous about it but Paradise Living made me feel I was not alone. 100% recommended.
                  </div>
                </div>
              </>
            )}
            <div className="block md:hidden  pt-[15px] px-[15px] text-sm relative z-10">
              <button
                className="text-[#00D3DB] hover:underline"
                onClick={handleReadMore}
              >
                {showMore ? 'Read Less' : 'Read More'}
              </button>
            </div>
          </div>

          <div className="hidden md:block flex-col  pt-[80px]">
            <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
              <div className="flex items-center space-x-4 ">
                <Avatar
                  hasChecked
                  hasCheckedClass="w-0 h-0 "
                  sizeClass="h-[70px] w-[70px]"
                  radius="rounded-full"
                  imgUrl={avatar3}
                />
                <div >
                  <a className="block text-md font-semibold">
                  Ronda
                  </a>
                  <a className="block text-md font-semibold mt-[-3px]">
                  Johnson
                  </a>

                </div>
              </div>
              <div className=" py-[10px] ">
                <FiveStartIconForRate defaultPoint={4.9} iconClass="w-3 h-3" className="space-x-0.5" />
              </div>
              <div className="py-[2px] text-[10px] leading-normal font-light">
              Smooth sailing from the beginning to the end. That’s all I have to say. Good to know there are people are there that are protecting your decision making. Extremely professional and reliable.
              </div>
            </div>
            <div className="m-[15px] p-[15px] w-[220px] h-[290px] bg-white rounded-xl">
              <div className="flex items-center space-x-4 ">
                <Avatar
                  hasChecked
                  hasCheckedClass="w-0 h-0 "
                  sizeClass="h-[70px] w-[70px]"
                  radius="rounded-full"
                  imgUrl={avatar4}
                />
                <div >
                  <a className="block text-md font-semibold">
                    Crystal 
                  </a>
                  <a className="block text-md font-semibold mt-[-3px]">
                  Garner
                  </a>

                </div>
              </div>
              <div className=" py-[10px] ">
                <FiveStartIconForRate defaultPoint={5.0} iconClass="w-3 h-3" className="space-x-0.5" />
              </div>
              <div className="py-[2px] text-[10px] leading-normal font-light">
              Best decision of my life. I can’t say enough about my experience. I dealt with many Real Estate Agents in the past and everything I heard was “Buy, buy buy”. The team at Paradise Living held my hand and work with me to find not just what I wanted but what I need it. Superstar team.
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default SectionHeroArchivePage;
